// components/ReturnOrReassignModal.js
import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Spinner, Alert } from 'react-bootstrap';
import api from '../services/api';

const BROKERS_API_URL = api.defaults.baseURL + '/manager/users/broker';

const ReturnOrReassignModal = ({ show, onHide, onConfirm, isSaving }) => {
  const [brokers, setBrokers] = useState([]);
  const [selectedBrokerId, setSelectedBrokerId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch brokers only when the modal is opened
    if (show) {
      setIsLoading(true);
      setError(null);
      setSelectedBrokerId(''); // Reset selection
      
      const token = localStorage.getItem('authToken');
      fetch(BROKERS_API_URL, {
        method:"GET",
        headers: { 'Authorization': `Bearer ${token}` },
      })
        .then(async res => {
          if (!res.ok) throw new Error(await res.text());
          return res.json();
        })
        .then(data => {
          setBrokers(data);
        })
        .catch(err => {
          setError(`Failed to load brokers: ${err.message}`);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [show]);

  const handleConfirmReassign = () => {
    onConfirm(selectedBrokerId);
  };
  
  const handleConfirmReturnSame = () => {
    onConfirm(null); // Pass null to indicate returning to the same broker
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Return or Reassign Form</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        
        <p>Choose an option below. The form will be moved to 'Pending' status.</p>
        
        <div className="d-grid gap-2">
          <Button 
            variant="warning" 
            onClick={handleConfirmReturnSame}
            disabled={isSaving}
          >
            {isSaving ? 'Processing...' : 'Return to Same Broker'}
          </Button>
        </div>

        <hr />

        <h5>Reassign to a New Broker</h5>
        {isLoading ? (
          <div className="text-center">
            <Spinner animation="border" />
            <p>Loading brokers...</p>
          </div>
        ) : (
          <Form.Group>
            <Form.Label>Select a new broker from the list:</Form.Label>
            <Form.Select 
              value={selectedBrokerId} 
              onChange={(e) => setSelectedBrokerId(e.target.value)}
              disabled={isSaving}
            >
              <option value="">-- Choose a broker to reassign --</option>
              {brokers.map(broker => (
                <option key={broker._id} value={broker._id}>{broker.name} ({broker.email})</option>
              ))}
            </Form.Select>
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isSaving}>
          Cancel
        </Button>
        <Button 
          variant="primary" 
          onClick={handleConfirmReassign}
          disabled={!selectedBrokerId || isSaving}
        >
          {isSaving ? 'Reassigning...' : 'Reassign Form'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReturnOrReassignModal;